import { Form } from 'factorial-form'

class Team extends Form {
  constructor(values: object) {
    super(values, {
      name: 'string',
      description: 'string',
      avatar: 'file',
    })
  }
}

export default Team
